import { Billpay } from "models/kiosk";

export const getObjectForLog = (billpay: Billpay) => {
    return {
        amountInserted: billpay.amountInserted,
        processCreateFailed: billpay.processCreateFailed,
        processUpdateFailed: billpay.processUpdateFailed,
        isSuccess: billpay.isSuccess,
        isFailedInAmss: billpay.isFailedInAmss,
        processFailed: billpay.processFailed,
        isTransactionCreated: billpay.isTransactionCreated,
        hasInsertedCash: billpay.hasInsertedCash,
        hasNextBalanceDue: billpay.hasNextBalanceDue,
        accountNumberLast4: billpay.accountNumberLast4,
        pastBalanceDueLeft: billpay.pastBalanceDueLeft,
        currentBalanceDueLeft: billpay.currentBalanceDueLeft,
        totalAmountDueLeft: billpay.totalAmountDueLeft,
        nextBalanceDue: billpay.nextBalanceDue,
        customer: billpay.customer,
        processId: billpay.processId,
        transactionId: billpay.transactionId,
        confirmationError: billpay.confirmationError,
        lastBanknoteId: billpay.lastBanknoteId,
        isProcessingComplete: billpay.isProcessingComplete,
    };
}